
'use strict';

(function () {
  if (!customElements.get('featured-slideshow')) {
    class FeaturedSlideshow extends HTMLElement {
      constructor() {
        super();

        this.swiper = null;
        this.slider = this.querySelector('.swiper');
        this.slides = this.querySelectorAll('.swiper-slide');

        // Read slider settings from the HTML data attributes
        const slidesPerView = parseFloat(this.dataset.slidesPerView) || 3;
        const spaceBetween = parseFloat(this.dataset.spaceBetween) || 0;
        const spaceBetweenPc =
          parseFloat(this.dataset.spaceBetweenPc) || spaceBetween;

        // Number of slides visible on each device
        const slidesPerViewMb = Math.min(this.slides.length, 1.2);
        const slidesPerViewTb = Math.min(this.slides.length, 2.2);
        const slidesPerViewPc = Math.min(
          this.slides.length,
          slidesPerView
        );

        // Swiper configuration
        this.swiperParams = {
          slidesPerView: slidesPerViewMb,
          spaceBetween: spaceBetween,
          grabCursor: true,
          allowTouchMove: true,
          simulateTouch: true,
          touchStartPreventDefault: false,
          threshold: 5,
          watchOverflow: true,

          breakpoints: {
            640: {
              slidesPerView: slidesPerViewTb,
              spaceBetween: spaceBetween,
            },

            1200: {
              slidesPerView: slidesPerViewPc,
              spaceBetween: spaceBetweenPc,
            },
          },
        };
      }

      connectedCallback() {
        if (!this.slider || this.swiper) return;

        // Initialize Swiper when the section is near the viewport
        if ('IntersectionObserver' in window) {
          this._observer = new IntersectionObserver(
            (entries) => {
              if (entries[0].isIntersecting) {
                this._observer.disconnect();
                this._observer = null;
                this.initSwiper();
              }
            },
            {
              rootMargin: '200px',
            }
          );

          this._observer.observe(this);
        } else {
          this.initSwiper();
        }
      }

      disconnectedCallback() {
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
      }

      initSwiper() {
        if (this.swiper || !this.slider) return;

        if (typeof Swiper === 'undefined') {
          console.error(
            'Featured Slideshow: Swiper library is not loaded.'
          );
          return;
        }

        this.swiper = new Swiper(
          this.slider,
          this.swiperParams
        );
      }
    }

    customElements.define(
      'featured-slideshow',
      FeaturedSlideshow
    );
  }
})();
